// extracted by mini-css-extract-plugin
module.exports = {"main":"AnalysisAssociatedTraits_main__tJfQA"};